import { AnimatePresence } from 'framer-motion'
import React from 'react'
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom'
import AccomodationDetails from '../Components/Accomodation/Details'
import Accomodation from '../Components/Accomodation/Index'
import Chat from '../Components/Chat/Index'
import ActiveCommunity from '../Components/Community/ActiveCommunity'
import Community from '../Components/Community/Community'
import Details from '../Components/Education/Details'
import Education from '../Components/Education/Index'
import Home from '../Components/Home/Index'
import Locate from '../Components/Locate/Index'
import Post from '../Components/Post/Index'
import Profile from '../Components/Profile/Index'
import Services from '../Components/Services'
import ServicesDetails from '../Components/Services/Details'
import VoiceMenuContainer from '../globalComponents/VoiceMenuContainer'
import PostDetails from '../Components/Topics/Details'
import SearchPosts from '../Components/Topics/Search'
import Error from '../Components/404'

function DashboardRoute() {
  const uselocation = useLocation()
  const { url, path } = useRouteMatch()
  return (
    <AnimatePresence exitBeforeEnter>
      <Switch location={uselocation} key={uselocation.pathname}>
        <Route exact path="/home">
          <Home />
        </Route>
        <Route exact path="/home/search">
          <SearchPosts />
        </Route>
        <Route exact path="/home/topic/:id">
          <PostDetails />
        </Route>
        <Route exact path="/home/chat">
          <Chat />
        </Route>
        <Route exact path="/home/locate">
          <Locate />
        </Route>
        {/* <Route exact path="/home/post">
          <Post />
        </Route> */}
        <Route exact path="/home/accomodation">
          <Accomodation />
        </Route>
        <Route exact path="/home/profile">
          <Profile />
        </Route>
        <Route exact path="/home/services">
          <Services />
        </Route>
        <Route exact path="/home/services/details">
          <ServicesDetails />
        </Route>
        {/* <Route exact path="/home/chat/com:id">
          <ActiveCommunity />
        </Route> */}
        <Route exact path="/home/accomodation/details">
          <AccomodationDetails />
        </Route>
        <Route exact path="/home/community/">
          <Community />
        </Route>
        <Route exact path="/home/community/com:id">
          <ActiveCommunity />
        </Route>
        <Route exact path="/home/education">
          <Education />
        </Route>
        <Route exact path="/home/education/details">
          <Details />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
      <VoiceMenuContainer />
    </AnimatePresence>
  )
}

export default DashboardRoute
